import { Loading } from '@octano/global-ui';
import { createContext, useEffect, useState } from 'react';

import { useParameters } from '../hooks/useParameters';
import { ParametersContextType } from '../types/parametersTypes';

export const ParametersContext = createContext({} as ParametersContextType);

const ParametersLoaderProvider = (props: any) => {
  const {
    loadCountries,
    loadDefaultCountry,
    loadRegionsAndCommunes,
    loadInstitutionTypes,
  } = useParameters();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    Promise.all([
      loadCountries(),
      loadDefaultCountry(),
      loadRegionsAndCommunes(),
      loadInstitutionTypes(),
    ]).then(() => {
      setLoading(false);
    });
  }, [
    loadCountries,
    loadDefaultCountry,
    loadRegionsAndCommunes,
    loadInstitutionTypes,
  ]);
  if (loading) {
    return (
      <div className="text-center">
        <Loading textBody="" className="m-auto" />
      </div>
    );
  }
  return props.children;
};

export default ParametersLoaderProvider;
